const axios = require('axios');

export default class SignupBackend {

	constructor(w = '', ws = '') {
		this.callback = '/labackend/';
		this.w = w;
		this.ws = ws;
	}

	checkUsername(username) {
		return axios.get(this.callback + 'username', {
			params: {
				username
			}
		}).then((response) => {
			return response;
		});
	}

	checkEmail(email) {
		return axios.get(this.callback + 'email', {
			params: {
				email
			}
		}).then((response) => {
			return response;
		});

	}

	checkSignup(username, email) {
		return axios.get(this.callback + 'check', {
			params: {
				username,
				email,
				w: this.w,
				ws: this.ws
			}
		}).then((response) => {
			return response;
		});
	}
}
